import React, { Component } from "react";
import { message } from "antd";
import axios from "../../../axios/axios";
import LoadingOverlay from "react-loading-overlay";
import { logo_image } from "../../../assets/images";
import { Col, Row } from "react-bootstrap";

export default class TravelCertificateDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,

      certificate_details: {},
    };
  }

  componentDidMount = () => {
    this.getCertificateDetails();
  };

  getCertificateDetails = () => {
    this.setState({ isLoading: true });
    axios
      .get(`/get-travel-certificate/${this.props.match.params.id}`)
      .then((res) => {
        this.setState({ isLoading: false });
        if (res.data.status) {
          this.setState({ certificate_details: res.data.certificate_details });
          // setTimeout(() => {
          //   this.setState({ isLoading: false });
          //   setTimeout(() => {
          //     this.printDocument();
          //   }, 1000);
          // }, 5000);
        } else {
          this.setState({ isLoading: false });
          message.error(res.data.message);
        }
      })
      .catch((err) => {
        console.error(err);
        this.setState({ isLoading: false });
        message.error("Something went wrong");
      });
  };

  printDocument = () => {
    let printContents = document.getElementById("print_content").innerHTML;
    let originalContents = document.body.innerHTML;

    document.body.innerHTML = printContents;

    window.print();

    // document.body.innerHTML = originalContents;
    // window.location.pathname = "create-pdf";
    window.close();
  };

  render() {
    let { certificate_details } = this.state;

    return (
      <LoadingOverlay spinner active={this.state.isLoading} text="Loading...">
        <div
          className="pdf_inner_inner_box1"
          id="print_content"
          width="2480px"
          height="3508px"
        >
          <div className="pdf_boxi1">
            <div className="create_pdfff1">
              <div className="pdf_banner">
                <img
                  src={certificate_details.banner}
                  alt="Travel Certificate"
                />
              </div>
              <div className="pdf_content">
                <Row>
                  <Col lg="3" md="4" sm="12" className="padding_top30px">
                    <div className="pdf_price_img">
                      <img
                        src={certificate_details.pricetag}
                        className="img-fluid"
                      />
                    </div>
                    <div className="scan_code code_scan">
                      <img
                        src={`https://chart.googleapis.com/chart?cht=qr&chl=${certificate_details.qr_code}${certificate_details.referral_code}/${certificate_details.certificate_code}%2F&chs=180x180&choe=UTF-8&chld=L%7C2`}
                        className="img-fluid"
                      />
                    </div>
                    <div className="pdf_logo_img logo_pdf">
                      <img src={logo_image} className="img-fluid" />
                    </div>
                  </Col>
                  <Col lg="9" md="8" sm="12">
                    <div className="certificate_terms inner_termmmms">
                      <h2>Terms of the Certificate</h2>
                      <div
                        className="text-justify"
                        dangerouslySetInnerHTML={{
                          __html: certificate_details.certificate_description,
                        }}
                      />

                      <h3>GET YOUR CERTIFICATE TODAY!</h3>
                      <div className="go_online online_go">
                        <p>Go Online: http://redeem.tripvalet.com</p>
                        <p>
                          Enter Referral Code:{" "}
                          {certificate_details.referral_code}
                        </p>
                        <p>
                          Certificate Code:
                          {certificate_details.certificate_code}
                        </p>
                      </div>
                    </div>
                  </Col>
                  <div className="foot_cont">
                    <p>
                      If you have general questions about your certificate
                      please email support@tripvalet.com Monday to Friday from
                      9am to 5pm Central Time.
                    </p>
                  </div>
                </Row>
              </div>
            </div>
          </div>
        </div>
      </LoadingOverlay>
    );
  }
}
